// extracted by mini-css-extract-plugin
export var addButton = "_dq-4";
export var contentBlockImage = "_dq-i";
export var contentBlockWidgetPreview = "_dq-g";
export var fulfillmentCutoffWidgetPreview = "_dq-9";
export var imageBackdrop = "_dq-6";
export var imageIcon = "_dq-8";
export var lowProfileImageContainer = "_dq-b";
export var lowProfileImageIcon = "_dq-f";
export var lowProfileImageIconContainer = "_dq-e";
export var lowProfileImagePlaceholder = "_dq-d";
export var lowProfileProductImage = "_dq-c";
export var lowProfileProductUpsellWidgetPreview = "_dq-a";
export var productCard = "_dq-5";
export var productImage = "_dq-7";
export var productReviewsWidgetPreview = "_dq-h";
export var progressBar = "_dq-1";
export var progressBarFill = "_dq-2";
export var progressBarTrack = "_dq-3";
export var shippingOptionWidgetPreview = "_dq-j";
export var shippingUpsellProgressBar = "_dq-k";
export var thresholdUpsellWidgetPreview = "_dq-0";